import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './_core/core.module';
import { SearchStartModule } from './search-start/search-start.module';
import { SearchResultsModule } from './search-results/search-results.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { GoogleApiService } from './_core/services/google-api.service';
import { ErrorHandlerComponent } from './error-handler/error-handler.component';
import { ActionPasser, Utils, Logger } from "lo-bahamut-v1";
import { Grandmaster } from "lo-bahamut";
import { ApiBaseInterceptorService } from './_core/interceptors/api-base-interceptor.service';
import {SearchStartV2Component} from "./search-start-v2/search-start-v2.component";
import {SearchStartV2Module} from "./search-start-v2/search-start-v2.module";
import {SearchResultsV2Module} from "./search-result-v2/search-results-v2.module";
import { CarefindrAiModule } from './carefindr-ai/carefindr-ai.module';
import {NlsLandingPageModule} from "./nls-landing-page/nls-landing-page.module";
import {NlsSearchResultsV2Module} from "./nls-search-result-v2/nls-search-results-v2.module";
import {IFrameModule} from "./iframe/iframe.module";

@NgModule({
  declarations: [AppComponent, ErrorHandlerComponent],
  imports: [
    Grandmaster,
    HttpClientModule,
    BrowserModule,
    CoreModule,
    AppRoutingModule,
    SearchStartModule,
    SearchResultsModule,
    SearchStartV2Module,
    SearchResultsV2Module,
    FormsModule,
    CarefindrAiModule,
    NlsLandingPageModule,
    NlsSearchResultsV2Module,
    IFrameModule
  ],
  providers: [
    Grandmaster,
    ActionPasser,
    Utils,
    Logger,
    GoogleApiService,
    {
      provide: APP_INITIALIZER,
      useFactory: (apiService: GoogleApiService) => () =>
        apiService.initializeGoogleApi(),
      deps: [GoogleApiService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiBaseInterceptorService,
      multi: true
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
